/**
 * Contrato com o backend (rotas /notifications/*, autenticadas, exigem plano Pro - 403 caso contrario).
 * - POST /opt-in       body { whatsappNumber } -> { whatsappPhone, whatsappOptedIn, whatsappDailySummary }
 * - POST /opt-out      sem body               -> { whatsappPhone, whatsappOptedIn, whatsappDailySummary }
 * - PUT  /preferences  body { whatsappDailySummary } -> { whatsappPhone, whatsappOptedIn, whatsappDailySummary }
 * whatsappNumber deve estar em formato E.164 (ex: +5511999998888).
 */
import api from './axios';

export function optInWhatsApp(whatsappNumber) {
  return api.post('/notifications/opt-in', { whatsappNumber }).then(res => res.data);
}

export function optOutWhatsApp() {
  return api.post('/notifications/opt-out').then(res => res.data);
}

export function updateNotificationPreferences(data) {
  return api.put('/notifications/preferences', data).then(res => res.data);
}
